export const URL_API =
  "https://server-zing-mp3-dgoywdph8-levietphu.vercel.app/api/";
export const MV_API =
  "https://server-zing-mp3-dgoywdph8-levietphu.vercel.app/api/listmv?id=";
export const API_CATEGORY =
  "https://server-zing-mp3-dgoywdph8-levietphu.vercel.app/api/categorymv?id=";

export const API_INFO_SONG =
  "https://server-zing-mp3-dgoywdph8-levietphu.vercel.app/api/infosong?id=";

export const PLAYLIST_API =
  "https://server-zing-mp3-dgoywdph8-levietphu.vercel.app/api/detailplaylist?id=";
export const VIDEO_API =
  "https://server-zing-mp3-dgoywdph8-levietphu.vercel.app/api/video?id=";
export const SEARCH =
  "https://server-zing-mp3-dgoywdph8-levietphu.vercel.app/api/search?keyword=";
export const LYRIC =
  "https://server-zing-mp3-dgoywdph8-levietphu.vercel.app/api/lyric?id=";
